import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import api from "../Auth/Middleware";

const classOptions = [
  { value: 6, label: "6th" },
  { value: 7, label: "7th" },
  { value: 8, label: "8th" },
  { value: 9, label: "9th" },
  { value: 10, label: "10th" },
  { value: 11, label: "11th" },
  { value: 12, label: "12th" },
];

const Courses = {
  Maths: 1,
  Science: 2,
  Physics: 3,
  Chemistry: 4,
};

const coursesByClass = {
  6: [Courses.Maths, Courses.Science],
  7: [Courses.Maths, Courses.Science],
  8: [Courses.Maths, Courses.Science],
  9: [Courses.Maths, Courses.Science],
  10: [Courses.Maths, Courses.Science],
  11: [Courses.Maths, Courses.Physics, Courses.Chemistry],
  12: [Courses.Maths, Courses.Physics, Courses.Chemistry],
};

const EditStudent = ({
  openEdit,
  onEditClose,
  studentDetail,
  id,
  onEditSuccess,
  onEditFail,
}) => {
  const [studentData, setStudentData] = useState(studentDetail);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setStudentData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (studentDetail) {
      const formattedDateOfBirth = studentDetail.dateOfBirth.split("T")[0];
      const formattedDateOfAdmission =
        studentDetail.dateOfAdmission.split("T")[0];
      setStudentData((prevData) => ({
        ...prevData,
        ...studentDetail,
        dateOfBirth: formattedDateOfBirth,
        dateOfAdmission: formattedDateOfAdmission,
      }));
    }
  }, [studentDetail]);

  const handleClassChange = (event) => {
    const selectedClass = event.target.value;
    setStudentData((prevData) => ({
      ...prevData,
      class: selectedClass,
      courses: [],
    }));
  };

  const validateMobileNumber = (mobileNumber) => {
    if (mobileNumber === "") {
      return true;
    }
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobileNumber);
  };

  const handleCourseChange = (event) => {
    const selectedCourses = Array.from(event.target.value);
    const selectedClass = studentData.class;
    const availableCourses = coursesByClass[selectedClass] || [];
    const filteredCourses = selectedCourses.filter((course) =>
      availableCourses.includes(course)
    );

    setStudentData((prevData) => ({
      ...prevData,
      courses: filteredCourses,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await api.put(
        `student/EditStudent?id=${id}`,
        studentData
      );
      if (response.status === 200) {
        onEditSuccess();
        onEditClose();
      }
    } catch (error) {
      onEditFail();
      onEditClose();
    }
  };

  return (
    <>
      <Dialog open={openEdit} onClose={onEditClose}>
        <DialogTitle>Edit Student</DialogTitle>
        <DialogContent>
          {
            <div className="container-fluid my-2 d-flex align-items-center justify-content-center">
              <div className="row">
                <div className="col-md-12">
                  <div className="card shadow-sm p-4">
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="First Name"
                              name="firstName"
                              required
                              fullWidth
                              value={studentData.firstName}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="Last Name"
                              name="lastName"
                              required
                              fullWidth
                              value={studentData.lastName}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="Date of Birth"
                              name="dateOfBirth"
                              required
                              type="date"
                              fullWidth
                              value={studentData.dateOfBirth}
                              onChange={handleInputChange}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="Date of Admission"
                              name="dateOfAdmission"
                              required
                              type="date"
                              fullWidth
                              value={studentData.dateOfAdmission}
                              onChange={handleInputChange}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                              <InputLabel id="class-label">Class</InputLabel>
                              <Select
                                labelId="class-label"
                                label="Class"
                                name="class"
                                required
                                value={studentData.class}
                                onChange={handleClassChange}
                              >
                                {classOptions.map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="Father's Name"
                              name="fatherName"
                              required
                              fullWidth
                              value={studentData.fatherName}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                              <InputLabel id="courses-label">
                                Courses
                              </InputLabel>
                              <Select
                                labelId="courses-label"
                                multiple
                                label="Courses"
                                required
                                value={studentData.courses}
                                onChange={handleCourseChange}
                                disabled={studentData.class === ""}
                                renderValue={(selected) => selected.join(", ")}
                              >
                                {(coursesByClass[studentData.class] || []).map(
                                  (course) => (
                                    <MenuItem key={course} value={course}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={studentData.courses.includes(
                                              course
                                            )}
                                          />
                                        }
                                        label={Object.keys(Courses).find(
                                          (key) => Courses[key] === course
                                        )}
                                      />
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="Student Contact"
                              name="studentContact"
                              required
                              fullWidth
                              value={studentData.studentContact}
                              onChange={handleInputChange}
                              inputProps={{
                                minLength: 10,
                                maxLength: 10,
                                pattern: "^[6-9]\\d{9}$",
                              }}
                              error={
                                !validateMobileNumber(
                                  studentData.studentContact
                                )
                              }
                              helperText="Please enter a valid 10-digit mobile number"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="Parent Contact"
                              name="parentContact"
                              required
                              fullWidth
                              value={studentData.parentContact}
                              onChange={handleInputChange}
                              inputProps={{
                                minLength: 10,
                                maxLength: 10,
                                pattern: "^[6-9]\\d{9}$",
                              }}
                              error={
                                !validateMobileNumber(studentData.parentContact)
                              }
                              helperText="Please enter a valid 10-digit mobile number"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              label="School"
                              name="school"
                              required
                              fullWidth
                              value={studentData.school}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              label="Address"
                              name="address"
                              required
                              fullWidth
                              value={studentData.address}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Button
                              type="submit"
                              variant="contained"
                              color="primary"
                            >
                              Save
                            </Button>
                          </Grid>
                        </Grid>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={onEditClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditStudent;
